export var ProductTourMutationTypes;
(function (ProductTourMutationTypes) {
    ProductTourMutationTypes["INIT_STATE"] = "INIT_STATE";
    ProductTourMutationTypes["SET_RUNNING"] = "SET_RUNNING";
    ProductTourMutationTypes["SET_ACTIVE_TOUR_ID"] = "SET_ACTIVE_TOUR_ID";
    ProductTourMutationTypes["SET_CURRENT_STEP_INDEX"] = "SET_CURRENT_STEP_INDEX";
})(ProductTourMutationTypes || (ProductTourMutationTypes = {}));
